export default "__VITE_ASSET__CZZQcNEL__"